import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';
// import moment from 'moment';

interface JobItem {
  id: string;
  [key: string]: any;
}

interface JobsState {
  items: JobItem[];
  loading: boolean;
  error: string | null;
}

const initialState: JobsState = {
  items: [],
  loading: false,
  error: null,
};

const jobsSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {
    // Other job-specific actions can be added here
  },
  extraReducers: (builder) => {
    builder.addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{
      jobs?: JobItem[];
      page?: number;
    }>) => {
      // React Native file cleanup logic (commented out for web)
      // Clear any old photos from storage to keep app size to minimum
      // Delete any folders not modified for 30 days
      // RNFS.readDir(RNFS.DocumentDirectoryPath + '/jobs')
      //   .then((result) => {
      //     result.forEach((folder) => {
      //       // Folder has not been used for 30 days and not in current bookings list
      //       if (moment().diff(moment(folder.mtime), 'days') > 30 && 
      //           !action.payload.jobs?.find((job) => job.id === parseInt(folder.name))) {
      //         console.log("unlinking folder " + folder.name);
      //         RNFS.unlink(folder.path).catch((err) => {
      //           console.log(err.message, err.code);
      //         });
      //       }
      //     });
      //   })
      //   .catch((err) => {
      //     console.log(err.message, err.code);
      //   });

      if (action.payload.page) {
        if (action.payload.jobs && action.payload.jobs.length > 0) {
          state.items = concatAndDeDuplicateObjects('id', state.items, action.payload.jobs);
        }
      } else {
        state.items = action.payload.jobs || [];
      }
    });
  },
});

export const {
  // Job-specific actions would be exported here
} = jobsSlice.actions;

export default jobsSlice.reducer;

// Selectors
export const selectJobById = (state: any, jobId: string) => {
  return state.jobs.items.find((job: JobItem) => job.id === jobId);
};